import { render, staticRenderFns } from "./cRecipes.vue?vue&type=template&id=f8bea6fe&scoped=true"
import script from "./cRecipes.vue?vue&type=script&lang=js"
export * from "./cRecipes.vue?vue&type=script&lang=js"
import style0 from "./cRecipes.vue?vue&type=style&index=0&id=f8bea6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bea6fe",
  null
  
)

export default component.exports